import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CouponsDTO, CouponsFilters } from '../../models/coupons';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';


@Injectable({
  providedIn: 'root',
})
export class LaravelCouponsService {
  constructor(private httpClient: HttpClient) {}

  private get ROUTES() {
    return {
      list: environment.baseUrl + '/api/discount-coupons',
      show: environment.baseUrl + '/api/discount-coupons',
      store: environment.baseUrl + '/api/discount-coupons',
      destroy: environment.baseUrl + '/api/discount-coupons',
    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: CouponsFilters,
    includes?: string[]
  ): Observable<ListResultDTO<CouponsDTO>> {
    let params: any = {};
    if (order) params['order'] = order;
    if (direction) params['direction'] = direction;
    if (includes) params['includes[]'] = includes;
    if (filters?.search) params['search'] = filters.search;

    if (per_page) {
      params['per_page'] = '' + per_page;
      if (page) params['page'] = '' + page;
      return this.httpClient.get<ListResultDTO<CouponsDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params }),
      });
    } else {
      return this.httpClient
        .get<CouponsDTO[]>(this.ROUTES.list, {
          params: new HttpParams({ fromObject: params }),
        })
        .pipe(
          map((results) => ({
            data: results,
            total: results.length,
          }))
        );
    }
  }

  public show(id: number): Observable<CouponsDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<CouponsDTO>(`${this.ROUTES.show}/${id}`, {
      params: new HttpParams({ fromObject: params }),
    });
  }

  public upsert(coupon: CouponsDTO): Observable<CouponsDTO> {
    if (coupon.id) {
      return this.httpClient.put<CouponsDTO>(`${this.ROUTES.store}/${coupon.id}`, coupon);
    } else {
      return this.httpClient.post<CouponsDTO>(this.ROUTES.store, coupon);
    }
  }

  public delete(id: number): Observable<any> {
    return this.httpClient.delete(`${this.ROUTES.destroy}/${id}`);
  }
}
